import { VenomVersion } from 'client/data/models/version';
import { PageModel } from 'client/data/models/page';
import { RequestModel } from 'client/data/models/request';
import { XHeaders } from 'client/data/models/x-headers';

export const CLIENT_ARTIFACT = 'venom';

function updateTimingMetric(timing, name) {
  const newWaterfallLevel = timing.endingWaterfallLevel + 1;

  const myTiming = { duration: null, startTime: Date.now(), waterfallLevel: newWaterfallLevel };

  // eslint-disable-next-line no-param-reassign
  timing[name] = myTiming;

  return myTiming;
}

function updateResponseMetric(timing, myTiming) {
  if (myTiming.waterfallLevel > timing.endingWaterfallLevel) {
    // eslint-disable-next-line no-param-reassign
    timing.endingWaterfallLevel = myTiming.waterfallLevel;
  }

  // eslint-disable-next-line no-param-reassign
  myTiming.endTime = Date.now();
  // eslint-disable-next-line no-param-reassign
  myTiming.duration = myTiming.endTime - myTiming.startTime;
}

function resolveMetricOptions(options, context) {
  const metricHeaders = {
    'x-artifact-id': CLIENT_ARTIFACT,
  };

  const pageName = context.getValue('page.name', PageModel, false);
  const pageCategory = context.getValue('page.category', PageModel, false);
  const apiGatewayInvalidate = context.getValue('apiGatewayInvalidate', PageModel, false);
  const venomVersion = context.getValue('version', VenomVersion, false);
  const xTraceId = context.getValue('x-trace-id', XHeaders, false);
  const xTraceSeq = context.getValue('x-trace-seq', XHeaders, false);
  const protocol = context.getValue('protocol', RequestModel, false);
  const hostName = context.getValue('hostName', RequestModel, false);
  const url = context.getValue('url', RequestModel, false);

  metricHeaders['x-client-action-name'] = `${pageName}.${context.displayName}`;
  metricHeaders['x-artifact-version'] = venomVersion;
  metricHeaders['x-trace-id'] = xTraceId;

  if (pageName) metricHeaders['x-edw-page-name'] = pageName;
  if (pageCategory) metricHeaders['x-edw-page-cat'] = pageCategory;

  if (xTraceSeq) metricHeaders['x-trace-seq'] = xTraceSeq;

  const referer = `${protocol}://${hostName}${url}`;
  metricHeaders['x-referer'] = referer;
  metricHeaders.Referer = referer;

  const cacheHeaders = apiGatewayInvalidate ? { 'Cache-Control': 'no-cache' } : {};

  const headers = {
    ...options.headers,
    ...metricHeaders,
    ...cacheHeaders,
  };

  return {
    ...options,
    headers,
  };
}

function isEdmundsGraphQL(api) {
  return typeof api.query === 'function';
}

export function withMetrics(api, context) {
  const { timing } = context;
  return isEdmundsGraphQL(api)
    ? {
        query(query, variables = {}, options = {}) {
          const myTiming = updateTimingMetric(timing, `query:${JSON.stringify(query)}`);
          const optionsWithMetrics = resolveMetricOptions(options, context);

          return api.query(query, variables, optionsWithMetrics).then(response => {
            updateResponseMetric(timing, myTiming);

            return response;
          });
        },
      }
    : {
        fetch(resourcePath, options = {}) {
          const myTiming = updateTimingMetric(timing, `fetch:${resourcePath}`);
          const optionsWithMetrics = resolveMetricOptions(options, context);

          return api.fetch(resourcePath, optionsWithMetrics).then(response => {
            updateResponseMetric(timing, myTiming);

            return response;
          });
        },
        fetchJson(resourcePath, options = {}) {
          const myTiming = updateTimingMetric(timing, `fetch:${resourcePath}`);
          const optionsWithMetrics = resolveMetricOptions(options, context);

          return api.fetchJson(resourcePath, optionsWithMetrics).then(response => {
            updateResponseMetric(timing, myTiming);

            return response;
          });
        },
      };
}
